import { ReactNode } from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import clsx from "clsx";
import IntroAnchor from "@/app/features/shared/__to_be_integrated/ui/IntroAnchor";

export function SpecialExhibitionsRootFrame({ children }: { children: ReactNode }) {
    return <>{children}</>;
}

export function SpecialExhibitionsIntroFrame({ children }: { children: ReactNode }) {
    return <div className="relative">{children}</div>;
}

export function SpecialExhibitionsContentFrame({ children }: { children: ReactNode }) {
    return (
        <Stack
            spacing={8}
            alignItems="center"
            sx={{
                width: "100%",
                px: { xs: 4, md: "10%" },
                mt: 4,
                mb: 8,
            }}
        >
            <IntroAnchor />
            {children}
        </Stack>
    );
}

export function SpecialExhibitionsSectionFrame({
    children,
    heading,
    sectionId,
}: {
    children: ReactNode;
    heading: string;
    sectionId: string;
}) {
    const headingId = `${sectionId}-heading`;

    return (
        <Box
            component="section"
            id={sectionId}
            aria-labelledby={headingId}
            sx={{ width: "100%", mt: 4, mb: 8 }}
        >
            <Divider sx={{ pb: 4 }}>
                <Typography
                    id={headingId}
                    component="h2"
                    variant="h2"
                    color="text.secondary"
                    sx={{ whiteSpace: { xs: "normal", md: "nowrap" } }}
                >
                    {heading}
                </Typography>
            </Divider>
            {children}
        </Box>
    );
}

export function SpecialExhibitionsGridFrame({
    children,
    columns = { xs: 1, md: 3 },
    spacing = 4,
}: {
    children: ReactNode;
    columns?: { xs: number; md: number };
    spacing?: number;
}) {
    return (
        <Grid container columns={columns} spacing={spacing}>
            {children}
        </Grid>
    );
}

export function SpecialExhibitionImageFrame({
    children,
    className,
}: {
    children: ReactNode;
    className?: string;
}) {
    return (
        <div className={clsx("relative w-full h-full overflow-hidden", className)}>
            {children}
        </div>
    );
}

export function SpecialExhibitionCardFrame({ children }: { children: ReactNode }) {
    return (
        <Box sx={{ height: "100%" }}>
            {children}
        </Box>
    );
}
